var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-between"},[(!_vm.isHomePage)?_c('back-button'):_vm._e(),_c('u-spacer'),(!_vm.isExternalSite)?_c('qr-code-auth',{staticClass:"mr-2"}):_vm._e(),_c('user-profile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }